module.exports = __webpack_public_path__ + "static/media/VestasSans-Headline.6622facd.woff";